import { ObjectState } from "../ObjectState";
import { AvailableProject } from "./AvailableProject";
import { AvailableProjectResponse } from "./AvailableProjectResponse";
import { ProjectToAccess } from "./ProjectToAccess";
import { ProjectToAccessResponse } from "./ProjectToAccessResponse";
import { UserProjectAccess } from "./UserProjectAccess";
import { UserProjectAccessResponse } from "./UserProjectAccessResponse";

export class ProjectResponseMapper {
  mapAccessUserProjectResponse = (
    accessUserProjectResponse: UserProjectAccessResponse
  ): UserProjectAccess => {
    return {
      projectsToAccess: accessUserProjectResponse.projectToAccessResponses.map(
        (access) => {
          return this.mapProjectToAccessResponse(access);
        }
      ),
      userEmail: accessUserProjectResponse.userEmail,
      userName: accessUserProjectResponse.userName,
      userId: accessUserProjectResponse.userId,
      authorizationType: accessUserProjectResponse.authorizationType,
    };
  };

  mapProjectToAccessResponse = (
    projectToAccessResponse: ProjectToAccessResponse
  ): ProjectToAccess => {
    return {
      id: projectToAccessResponse.id,
      name: projectToAccessResponse.name,
      objectState: ObjectState.Original,
    };
  };

  mapAvailableProjectResponse = (
    availableProjectResponse: AvailableProjectResponse
  ): AvailableProject => {
    return {
      id: availableProjectResponse.id,
      name: availableProjectResponse.name,
    };
  };
}
